import "./learnertutorcreator.styles.scss"
import Tick from "../../assets/homepage/tick.png"

function LearnerTutorCreator(props) {
  return (
    <div className="learner-tutor-creator">
      <div className="content">
        <div className="text" style={{ order: props.reversed ? 2 : 1 }}>
          <img className="bow-image" src={props.bow_image} />
          <div className="headline">
            <h3>{props.headline}</h3>
          </div>
          {/* <div className="texts">
            <h4>{props.text}</h4>
          </div> */}
          <div className="benefits">
            {props.benefits.map((benefit, index) => {
              return (
                <div key={index} className="benefit">
                  <img src={Tick} alt="tick" className="tick" />
                  <div>
                    <h5 className="one">{benefit.one}</h5>
                    <h5>{benefit.two}</h5>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="image" style={{ order: props.reversed ? 1 : 2 }}>
          <img
            src={props.hero_image}
            alt="hero image"
            style={props.hero_image_styles}
          />
        </div>
      </div>
      <hr />
    </div>
  )
}

export default LearnerTutorCreator
